import ajax from '@/utils/ajax'
export default {
  //批量删除商机列表
  deleteSearchLabelByIds(data) {
    return ajax({
      url: 'gt6/trade/deleteSearchLabelByIds',
      method: 'POST',
      data
    })
  },
  getChildAccountListWithLogin(data) {
    return ajax({
      url: 'business/account/getChildAccountListWithLogin',
      method: 'POST',
      data
    })
  },
  // 账户安全提示确认
  ChangeThisMonthLoginTrue() {
    return ajax({
      url: 'business/user/ChangeThisMonthLoginTrue',
      method: 'POST',
    })
  },
  //获取报告导出KEY getReportDownloadInfoKey
  getReportDownloadInfoKey(data) {
    return ajax({
      url: '/gt6/search/getReportDownloadInfoKey',
      // url: '/gt6/search/getReportPdfPathTest',
      method: 'POST',
      data
    })
  },
  //获取报告导出KEY /api/gt6/search/downloadReportFile
  downloadReportFile(data) {
    return ajax({
      url: '/gt6/search/downloadReportFile',
      method: 'POST',
      responseType: 'blob',
      data,
    })
  },
  // 下载企业历史数据 downloadHistory
  downloadHistory(params) {
    return ajax({
      url: '/gt6/search/downloadHistory',
      method: 'GET',
      responseType: 'blob',
      params,
    })
  },
  // 获取提单详细页备注 /api/gt6/trade/getRemark
  getTradeRemark(params) {
    return ajax({
      url: '/gt6/trade/getRemark',
      method: 'GET',
      params,
    })
  },
  //保存提单详细页备注 /api/gt6/trade/billRemark
  setTradeRemark(data) {
    return ajax({
      url: 'gt6/trade/billRemark',
      method: 'POST',
      data
    })
  },
  //其它任务的订阅
  subscribeOther(data) {
    return ajax({
      url: 'gt6/public/subscribeOther',
      method: 'POST',
      data
    })
  },
  //订阅的一个状态
  getOtherSubscribeData(params) {
    return ajax({
      url: 'gt6/public/getOtherSubscribeData',
      method: 'GET',
      params,
    })
  },
  //获取标签数据 /api/gt6/dashboard/getLabel
  getCollectLabel(data) {
    return ajax({
      url: 'gt6/dashboard/getLabel',
      method: 'POST',
      data,
    })
  },
  //删除标签 /api/gt6/dashboard/deleteLabel
  deleteCollectLabel(data) {
    return ajax({
      url: 'gt6/dashboard/deleteLabel',
      method: 'POST',
      data,
    })
  },
  //删除标签 /api/gt6/dashboard/updateLabel
  updateCollectLabel(data) {
    return ajax({
      url: 'gt6/dashboard/updateLabel',
      method: 'POST',
      data,
    })
  },
  //总览工具列表
  toolkitList(params){
    return ajax({
      url: 'gt6/dashboard/toolkit/list',
      method: 'GET',
      params,
    })
  },
  //添加组件到页面
  AddToolkitList(data){
    return ajax({
      url: 'gt6/dashboard/toolkit',
      method: 'POST',
      data,
    })
  },
  //移除页面组件
    DeleteToolkitList(data){
      return ajax({
        url: `gt6/dashboard/toolkit/${data}`,
        method: 'DELETE',
        data,
      })
    },
    //修改页面组件
    EditToolkitList(data){
      return ajax({
        url: 'gt6/dashboard/toolkit',
        method: 'PUT',
        data,
      })
    },
    //获取组件的所有信息
    getToolkitList(params){
      return ajax({
        url: 'gt6/dashboard/toolkit/cus',
        method: 'GET',
        params,
      })
    },
    //获取组件内容
    getToolkitRetrieve(data){
      return ajax({
        url: 'gt6/dashboard/toolkit/retrieve',
        method: 'POST',
        data,
      })
    },
    //获取快捷入口的自定义列表
    getConvenientList(params){
      return ajax({
        url: 'gt6/dashboard/convenient/list',
        method: 'GET',
        params,
      })
    },
     //更新所有组件信息
    updatedToolkit(data) {
      return ajax({
        url: 'gt6/dashboard/toolkit/update',
        method: 'POST',
        data,
      })
    },
     // 获取关注与收藏的三项资料卡
    getFavorite() {
      return ajax({
        url: 'gt6/dashboard/getFavorite',
        method: 'GET',
      })
    },
    getTimezoneList() {
      return ajax({
        url: 'gt6/dashboard/timezone/list',
        method: 'GET',
      })
    },
    //获取汇率自定义列表
    getCurrencyList(params){
      return ajax({
        url: 'gt6/dashboard/currency/list',
        method: 'GET',
        params,
      })
    },
     //重置默认布局
    toolkitReset(data){
      return ajax({
        url: `gt6/dashboard/toolkit/reset/${data}`,
        method: 'POST',
        data,
      })
    }
   
}